module.exports = __webpack_public_path__ + "img/jacket-back-sub-raglan-hood.d3c130b1.png";